export var TabbedContentDataHooks;
(function (TabbedContentDataHooks) {
    TabbedContentDataHooks["activeContentContainer"] = "active-content";
    TabbedContentDataHooks["contentContainer"] = "content-container";
})(TabbedContentDataHooks || (TabbedContentDataHooks = {}));
//# sourceMappingURL=types.js.map